const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";
const SECURE_SUBDIRECTORY = "secure";
const RECAPTCHA_SITE_KEY = "6Ldvy8QUAAAAAHxZ7tD7g0pYeKr4ZSr-iXqOBsCX";
const USER_TOKEN = "userToken";
const MUST_QUOTE_PREFIX = "mustQuote_";
const QUOTATION_PREFIX = "quotation_";
const WHATSAPP = "https://api.whatsapp.com/send?phone=59898611998";
const CONTACT_FORM = "https://www.bse.com.uy/portal-comercial/contacto/";
const DUMMY_LINK = "http://www.bse.com.uy";
const YOUTUBE_LINK = "https://www.youtube.com/user/MarketingBSE";
const FACEBOOK_LINK = "https://www.facebook.com/BSEuruguay";
const TWITTER_LINK = "https://twitter.com/bseuruguay";
const INSTAGRAM_LINK = "https://www.instagram.com/bseuruguay/";
const LINKEDIN_LINK =
  "https://www.linkedin.com/company/banco-de-seguros-del-estado";
const SISTARBANC_URL = process.env.REACT_APP_SISTARBANC_URL;

export {
  API_BASE_URL,
  SECURE_SUBDIRECTORY,
  RECAPTCHA_SITE_KEY,
  USER_TOKEN,
  MUST_QUOTE_PREFIX,
  QUOTATION_PREFIX,
  WHATSAPP,
  CONTACT_FORM,
  DUMMY_LINK,
  YOUTUBE_LINK,
  FACEBOOK_LINK,
  TWITTER_LINK,
  INSTAGRAM_LINK,
  LINKEDIN_LINK,
  SISTARBANC_URL,
};
